import { useState } from "react"
import {
    Button,
    Grid
} from '@mui/material';
import ClientProfile from './clientProfile';
// material
import CreateClient from '../createClient';
// ----------------------------------------------------------------------

export default function Client({ project }) {
    let projectId = project.id
    const [addClient, setAddClient] = useState(false);
    const closeAddProject = () => setAddClient(false)
    const openAddProject = () => setAddClient(true)
    // eslint-disable-next-line no-unused-vars
    const [shouldRefetch, setShouldRefetch] = useState(false);
    const refetch = () => setShouldRefetch(true)
    if (project.client) {
        return <ClientProfile client={project.client} />
    } else {
        return (
            <>
                <CreateClient
                    open={addClient}
                    handleClose={closeAddProject}
                    projectId={projectId}
                    refetch={refetch}
                />
                <Grid container>
                    <Grid>
                        <Button variant={"filled"} onClick={openAddProject}>
                            Add Client
                        </Button>
                    </Grid>
                </Grid>
            </>
        )
    }
}
